import React from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";

const items = [
  {
    q: "They shipped an MVP to production in 6 weeks and kept improving post‑launch.",
    a: "VP Engineering, SaaS",
  },
  {
    q: "Clarity on costs and superb communication across time zones.",
    a: "COO, Retail",
  },
  {
    q: "Security posture improved dramatically without slowing teams down.",
    a: "CISO, Fintech",
  },
];

export const Testimonials = () => {
  return (
    <Section id="testimonials" eyebrow="What clients say" title="Testimonials">
      <div className="grid md:grid-cols-3 gap-6">
        {items.map((t, i) => (
          <Card key={i}>
            <p className="text-gray-800">“{t.q}”</p>
            <div className="mt-3 text-sm text-gray-500">— {t.a}</div>
          </Card>
        ))}
      </div>
    </Section>
  );
};
